import React from 'react'

import { COLORS } from '@btime/constants'
import Container from '../../../../components/structure/Container'

const styles = {
  root: {
    backgroundColor: COLORS.light3,
    padding: '3rem',
    position: 'relative'
  },

  content: {
    backgroundColor: COLORS.white,
    borderRadius: '5px',
    padding: '0.5cm',
    minHeight: '29.7cm',
    minWidth: '21cm',
    overflow: 'hidden'
  }
}

const Preview = ({ children }) => (
  <div style={styles.root}>
    <Container maxWidth="21cm">
      <div style={styles.content}>{children}</div>
    </Container>
  </div>
)

export default Preview
